import { useEffect } from 'react';
import { useParams } from 'react-router';
import { addDays } from 'date-fns';

import { setCookie } from '@labradorsports/utils';

import { AffiliateCouponCookieName } from '../../shared/constants.js';
import { useDispatch } from '../../shared/hooks/index.js';
import { useNavigateWithQuery } from '../../shared/providers/index.js';
import { billingApi } from '../../store/index.js';

const AffiliateLinkPage: FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigateWithQuery();
    const params = useParams();

    useEffect(() => {
        (async () => {
            const { data: result, error } = await dispatch(
                billingApi.endpoints.validateDiscountCodes.initiate({
                    couponCode: params.code,
                })
            );

            if (error) {
                navigate('/feed');
            } else {
                setCookie(AffiliateCouponCookieName, result.coupon.code, addDays(new Date(), 30));
                navigate('/profile/subscriptions/manage/create');
            }
        })();
    }, []);

    return null;
};

export default AffiliateLinkPage;
